import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/delivery/";

export function getDelivery(deliveryID) {
  return http.get(apiEndpoint + "delivery-detail/" + deliveryID);
}

export function getDeliveries(salesOrderID = 0, warehouseID = 0, outletID = 0) {
  return http.get(
    apiEndpoint +
      "deliveries/" +
      warehouseID +
      "/" +
      salesOrderID +
      "/" +
      outletID
  );
}

export function saveDelivery(delivery) {
  return http.post(apiEndpoint, delivery);
}

export function cancelDelivery(deliveryID = 0) {
  return http.delete(apiEndpoint + "cancel-delivery/" + deliveryID);
}

export function getItemsToBeDelivered(warehouseID) {
  return http.get(apiEndpoint + "items-to-delivered/" + warehouseID);
}

export function getItemsToBeDeliveredFromDeliveryOrder(
  deliveryOrderID,
  warehouseID
) {
  return http.get(
    apiEndpoint + "items-to-deliver-do/" + deliveryOrderID + "/" + warehouseID
  );
}

export function getItemsToBeDeliveredFromOperation(operationCardID = 0) {
  return http.get(apiEndpoint + "items-to-deliver-op/" + operationCardID);
}

export function getItemsToBeDeliveredFromSalesPos(
  salesPosID = 0,
  warehouseID = 0,
  outletID = 0
) {
  return http.get(
    apiEndpoint +
      "items-to-deliver-sp/" +
      salesPosID +
      "/" +
      warehouseID +
      "/" +
      outletID
  );
}

export function getItemsToBeDeliveredFromSalesReturn(
  salesReturnID = 0,
  warehouseID = 0
) {
  return http.get(
    apiEndpoint + "items-to-deliver-sr/" + salesReturnID + "/" + warehouseID
  );
}

export function getServicesToBeDelivered(salesOrderID = 0) {
  return http.get(apiEndpoint + "services-to-deliver/" + salesOrderID);
}
